module.exports = __webpack_public_path__ + "img/result_success.10fedbca.png";